import React from 'react';

interface Props {
  className?: string;
}

const Tracks: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="6"
    viewBox="0 0 17 6"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Tracks">
      <path
        clipRule="evenodd"
        d="M17 4L1 4L1 2L17 2L17 4Z"
        fill="currentColor"
        fillRule="evenodd"
        id="Vector 29 (Stroke)"
      />
      <path
        clipRule="evenodd"
        d="M-2.62267e-07 6L0 -4.37112e-08L1 0L1 6L-2.62267e-07 6Z"
        fill="currentColor"
        fillRule="evenodd"
        id="Line 70 (Stroke)"
      />
      <path
        clipRule="evenodd"
        d="M4 6L4 -4.37112e-08L5 0L5 6L4 6Z"
        fill="currentColor"
        fillRule="evenodd"
        id="Line 72 (Stroke)"
      />
      <path
        clipRule="evenodd"
        d="M12 6L12 -4.37112e-08L13 0L13 6L12 6Z"
        fill="currentColor"
        fillRule="evenodd"
        id="Line 76 (Stroke)"
      />
      <path
        clipRule="evenodd"
        d="M16 6L16 -4.37112e-08L17 0L17 6L16 6Z"
        fill="currentColor"
        fillRule="evenodd"
        id="Line 78 (Stroke)"
      />
      <path
        clipRule="evenodd"
        d="M8 6L8 -4.37112e-08L9 0L9 6L8 6Z"
        fill="currentColor"
        fillRule="evenodd"
        id="Line 74 (Stroke)"
      />
    </g>
  </svg>
);

export default Tracks;
